export type DealShareAttribution = {
  ref: string;
  deal?: string;
  retailer?: string;
  ts?: string;
};

export const DEAL_SHARE_COOKIE = 'dealShare';

export const DEAL_SHARE_COOKIE_MAX_AGE = 60 * 60 * 24 * 30;

// Kept free of js-cookie so the proxy can import it on the edge runtime.
export const buildDealShareCookie = (
  params: URLSearchParams
): string | null => {
  const ref = params.get('ref');
  // utm_source pins this to our own share links, so a stray ?ref= cannot claim a signup.
  if (!ref || params.get('utm_source') !== 'referral') return null;

  return JSON.stringify({
    ref,
    deal: params.get('deal') ?? undefined,
    retailer: params.get('retailer') ?? undefined,
    ts: new Date().toISOString()
  });
};

// Mirrors DealSharePayloadDto on the server.
const MAX_REF_LENGTH = 64;
const MAX_SLUG_LENGTH = 200;
const ISO_TIMESTAMP =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;

export const parseDealShareCookie = (
  raw: string | undefined
): DealShareAttribution | undefined => {
  if (!raw) return undefined;

  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed?.ref !== 'string' || parsed.ref.length > MAX_REF_LENGTH) {
      return undefined;
    }

    // Values the strict DTO would reject are dropped, or one crafted link 400s every signup.
    const slug = (value: unknown) =>
      typeof value === 'string' && value.length <= MAX_SLUG_LENGTH
        ? value
        : undefined;
    const ts =
      typeof parsed.ts === 'string' && ISO_TIMESTAMP.test(parsed.ts)
        ? parsed.ts
        : undefined;

    return {
      ref: parsed.ref,
      deal: slug(parsed.deal),
      retailer: slug(parsed.retailer),
      ts
    };
  } catch {
    // A hand-edited or truncated cookie must not block a registration.
    return undefined;
  }
};
